/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  UPDATE_DOC_REJECT_PROFILE: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.update.profile',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'UPDATE_DOC_REJECT_PROFILE' },
      },
    },
    UPDATE_DOC_REJECT_PROFILE: {
      invoke: {
        id: 'updateDocRejectProfile',
        src: 'updateDocRejectProfile',
        onDone: {
          target: 'UPDATE_DOC_REJECT_PROFILE_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'UPDATE_DOC_REJECT_PROFILE_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    UPDATE_DOC_REJECT_PROFILE_SUCCESS: {
      on: {
        START: { target: 'UPDATE_DOC_REJECT_PROFILE' },
      },
    },
    UPDATE_DOC_REJECT_PROFILE_FAILED: {
      on: {
        START: { target: 'UPDATE_DOC_REJECT_PROFILE' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
